export function parseFixedISOStringToDate(isoString: string): Date {
  const [datePart, timePart] = isoString.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute, second] = timePart
    .replace("Z", "")
    .split(":")
    .map(Number);
  return new Date(year, month - 1, day, hour, minute, second || 0);
}

export function toFixedISOString(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}.000Z`;
}
